export default __webpack_public_path__ + "static/media/0xc7AD46e0b8a400Bb3C915120d284AafbA8fc4735.75fa6063.svg";